module.exports = __webpack_public_path__ + "20db5e4f8b1e9a14163e19486c9c2b89.png";